import "../styleSheets/callToAction.css";
import "../styleSheets/hero.css";
import "../styleSheets/buttons.css";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { trackEvent } from "../utilities/analytics";

function CallToAction() {
  const navigate = useNavigate();
  const handleCTAButton = () => {
    trackEvent("pricing_cta_clicked");
    navigate("/Plans", { state: null });
  };
  const { t } = useTranslation("common");

  return (
    <section className="section-cta" aria-labelledby="cta-title">
      <div className="cta-container">
        <div className="cta-container-left">
          <div className="cta-container-text">
            <h2 id="cta-title" className="title">
              {t("pageBody.cta.ctaTitle")}
            </h2>
            <div className="divider" />
            <div className="text">{t("pageBody.cta.ctaText")}</div>
          </div>

          <div className="container-button-cta">
            <button
              type="button"
              className="btn btn--cta btn--size-cta"
              onClick={handleCTAButton}
            >
              {t("pageBody.hero.buttonText")}
            </button>
          </div>
        </div>
        <div className="cta-container-right cta-leaves-image" />
      </div>
    </section>
  );
}

export default CallToAction;
